import React from "react";
import Modal from "../../modals/ModalBoth";
import { ButtonClose, DeleteButton, FavoriteItem, ModalContentFav, ModalTitle, SelectButton, SelectButtons } from "../DepositElements";
import CloseIcon from "@mui/icons-material/Close";

const ModalFav = ({ open, handleClose, favorites, handleSelect, handleDelete }) => {

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      maxWidth="sm"
      fullWidth={false}
      children={
        <ModalContentFav>
          <ModalTitle>
            <h2>Métodos de Retiro</h2>
            <ButtonClose onClick={handleClose}>
              <CloseIcon />
            </ButtonClose>
          </ModalTitle>
          <div>
          {favorites.length>0 && favorites.map((favorite) => (
              <FavoriteItem key={favorite.id}>
                <div>
                  <strong style={{textTransform: 'uppercase'}}>{favorite.tipo}</strong>
                  {favorite.detalle?.split('=').map((x,i)=>i===1 ? <></> : <p>{x}</p>)}
                </div>
                <SelectButtons>
                  <SelectButton onClick={() => handleSelect(favorite)}>
                    Seleccionar
                  </SelectButton>
                  <DeleteButton onClick={() => handleDelete(favorite.id)}>
                    Eliminar
                  </DeleteButton>
                </SelectButtons>
              </FavoriteItem>
            ))}

            {favorites.length===0&& <h3 style={{margin: '1rem'}}>No se encontraron métodos de retiro favoritos...</h3>}
          </div>
        </ModalContentFav>
      }
    />
  );
};

export default ModalFav;
